import React, { useState } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/LoginForm.css';
import bg from "../../assets/images/bg.jpg";
import logo from "../../assets/images/logo.png";
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { authActions } from '../../sagas/authSlice';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { FaLock, FaUser } from 'react-icons/fa';
import NumericKeypad from './NumericKeypad';

const LoginForm = () => {
  const [activeField, setActiveField] = useState("username");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: { username: "", password: "" },
    onSubmit: (values) => {
      dispatch(
        authActions.loginRequest({
          user: values,
          onSuccess: (data) => {
            if (data.role === 'ROLE_GERANT' || data.role === 'ROLE_ADMIN') {
              navigate("/modules");
            } else if (data.role === 'ROLE_CAISSE') {
              navigate("/comptoire");
            } else {
              navigate("/sales");
            }
          },
          onError: () => {
            Swal.fire({
              icon: 'error',
              title: t('auth.loginError'),
            });
          }
        })
      );
    },
  });

  const handleKeyPress = (digit) => {
    formik.setFieldValue(
      activeField,
      (formik.values[activeField] || "") + digit
    );
  };

  const handleDelete = () => {
    formik.setFieldValue(
      activeField,
      formik.values[activeField].slice(0, -1)
    );
  };

  const handleClear = () => {
    formik.setFieldValue(activeField, "");
  };

  return (
    <div className="auth-wrapper">
      <div
        className="auth-background"
        style={{ backgroundImage: `url(${bg})` }}
      />
      <div className="auth-overlay" />

      <Container fluid className="auth-container">
        <div className="auth-center">
          <Card className="login-card glass">
            <CardBody className="login-card-body">
              {/* Logo */}
              <div className="login-header">
                <img src={logo} alt="MatjarPOS" className="login-logo-small" />
                <p className="login-subtitle">
                  {t('auth.loginPrompt')}
                </p>
              </div>

              {/* Form */}
              <Form onSubmit={formik.handleSubmit}>
                <FormGroup className="modern-form-group">
                  <Label>{t('auth.username')}</Label>
                  <div className="modern-input">
                    <FaUser />
                    <Input
                      readOnly
                      inputMode="none"
                      value={formik.values.username}
                      onClick={() => setActiveField("username")}
                      placeholder="Code utilisateur"
                    />
                  </div>
                </FormGroup>

                <FormGroup className="modern-form-group">
                  <Label>{t('auth.password')}</Label>
                  <div className="modern-input">
                    <FaLock />
                    <Input
                      type="password"
                      readOnly
                      inputMode="none"
                      value={formik.values.password}
                      onClick={() => setActiveField("password")}
                      placeholder="PIN"
                    />
                  </div>
                </FormGroup>

                <Button type="submit" className="login-button-modern w-100">
                  {t('auth.loginButton')}
                </Button>
              </Form>

              <NumericKeypad
                onPress={handleKeyPress}
                onDelete={handleDelete}
                onClear={handleClear}
              />

              {/* Footer */}
              <div className="text-center mt-4 login-footer">
                <span>© {new Date().getFullYear()} MatjarPOS</span>
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default LoginForm;
